export default __webpack_public_path__ + "static/media/ermetic-long.ff21fd88.png";